export class PrivacyManagerTCFv2Settings {constructor(c={}) { 
  Object.assign(this, {
    accordionsSpacing: { paddingLeft: 16, paddingRight: 16, paddingTop: 16, paddingBottom: 16 },
    accordionsFont: { fontSize: 13, fontWeight: '500', color: '#000000', fontFamily: 'arial, helvetica, sans-serif' },
    panelSpacing: { paddingLeft: 20, paddingRight: 20, paddingTop: 5, paddingBottom: 20 },
    panelFont: { fontSize: 13, fontWeight: '400', color: '#555555', fontFamily: 'arial, helvetica, sans-serif' },
    toggleType: 'basic',
    toggleColor: '#47d747',
    toggleActiveColor: '#ffffff',
    toggleText: 'On',
    toggleOffColor: '#cccccc',
    toggleOffActiveColor: '#ffffff',
    toggleOffText: 'Off',

    specialOnly: false,
    purposesText: 'Purposes',
    purposeInfo: 'You give an affirmative action to indicate that we can use your data for this purpose.',
    customPurposesText: 'Custom Purposes',
    customPurposesLetter: 'C',
    specialPurposesText: 'Special Purposes',
    specialPurposesInfo: 'We have a need to use your data for this processing purpose that is required for us to deliver services to you.',
    //consent label for purposes
    consentText: 'User Consent',
    //li label for purposes
    liText: 'Legitimate Interest',
    vendorConsentText: 'User Consent',
    vendorLiText: 'Legitimate Interest',
    liInfo: 'We have a need to use your data for this processing purpose that is required for us to deliver services to you.',
    rejectAllText: 'Reject All',
    acceptAllText: 'Accept All',

    featuresText: 'Features',
    featuresInfo: 'Features are a use of the data that you have already agreed to share with us',
    specialFeaturesText: 'Special Features',
    specialFeaturesInfo: 'Special Features are processing purposes that require your explicit consent',

    // IAB Categories
    iabConsent: 'Consent Purposes',
    iabLegInt: 'Legitimate Interest Purposes',
    iabFeatures: 'Features',
    iabSpecialFeatures: 'Special Features',
    iabSpecialPurposes: 'Special Purposes',

    alphabetizeVendors: false,
    vendorsText: 'Site Vendors',
    searchText: 'Search Site Vendors',
    otherText: 'Other Site Vendors',
    otherLetter: 'O',

    cookieText: 'Cookie Information',
    tableCategoryText: 'Category',
    tableCookieText: 'Cookie',
    tableDomainText: 'Domain',
    tableDurationText: 'Duration',

    statusText: 'Status',
    viewAllText: 'View All',
    viewLessText: 'View Less',
    acceptedAllText: 'Accepted All',
    partialConsentText: 'Partial Consent',
    rejectedAllText: 'Rejected All',

    minHeight: { type: 'auto', value: 1 },
    maxHeight: { type: 'px', value: 400 },
    languages: {},
    selectedLanguage: '',
    // for Vendor Content
    appleDataBrokerText: "Apple Data Broker",
    appleDataBrokerLetter: "A",
  });
  Object.assign(this, c);
}}

export const PrivacyManagerTCFv2Types = {
  height: {
    minHeight: { title: 'Min Scroll Height', type: 'Size' },
    maxHeight: { title: 'Max Scroll Height', type: 'Size' },
  },
  accordions: {
    accordionsSpacing: { title: 'Padding', type: 'Padding' },
    accordionsFont: { title: 'Font', type: 'Font' },
  },
  panel: {
    panelSpacing: { title: 'Padding', type: 'Padding' },
    panelFont: { title: 'Font', type: 'Font' },
  },
  'purpose content': {
    specialOnly: { title: 'Show Special Purposes in Leg. Interest only?', type: 'Switch' },
    purposesText: { title: 'Purposes', type: 'InputLanguage' },
    purposeInfo: { title: 'Purposes Info', type: 'InputLanguage' },
    customPurposesText: { title: 'Custom', type: 'InputLanguage' },
    customPurposesLetter: { title: 'Custom Icon', type: 'InputLanguage' },
    specialPurposesText: { title: 'Spec. Purposes', type: 'InputLanguage' },
    specialPurposesInfo: { title: 'Spec. Purposes Info', type: 'InputLanguage' },
    consentText: { title: 'Consent', type: 'InputLanguage' },
    liText: { title: 'Leg. Interest', type: 'InputLanguage' },
    liInfo: { title: 'Leg. Interest Info', type: 'InputLanguage' },
    acceptAllText: { title: 'Accept All', type: 'InputLanguage' },
    rejectAllText: { title: 'Reject All', type: 'InputLanguage' },
  },
  'feature content': {
    featuresText: { title: 'Features', type: 'InputLanguage' },
    featuresInfo: { title: 'Features Info', type: 'InputLanguage' },
    specialFeaturesText: { title: 'Special Features', type: 'InputLanguage' },
    specialFeaturesInfo: { title: 'Spec. Features Info', type: 'InputLanguage' },
  },
  'vendor content': {
    alphabetizeVendors : { title: 'Sort Vendors Alphabetically?', type: 'Switch' },
    vendorsText: { title: 'Vendors', type: 'InputLanguage' },
    searchText: { title: 'Search', type: 'InputLanguage' },
    otherText: { title: 'Others', type: 'InputLanguage' },
    otherLetter: { title: 'Other Icon', type: 'InputLanguage' },
    vendorConsentText: { title: 'Consent', type: 'InputLanguage' },
    vendorLiText: { title: 'Leg. Interest', type: 'InputLanguage' },
    appleDataBrokerText: { title: 'Apple Data Broker Description', type: 'InputLanguage' },
    appleDataBrokerLetter: { title: 'Apple Data Broker Icon', type: 'InputLanguage' },
  },
  'IAB Categories': {
    iabConsent: { title: 'Consent Purposes', type: 'InputLanguage' },
    iabLegInt: { title: 'Legitimate Interest Purposes', type: 'InputLanguage' },
    iabFeatures: { title: 'Features', type: 'InputLanguage' },
    iabSpecialFeatures: { title: 'Special Features', type: 'InputLanguage' },
    iabSpecialPurposes: { title: 'Special Purposes', type: 'InputLanguage' },
  },
  'cookie content': {
    cookieText: { title: 'Cookie Info', type: 'InputLanguage' },
    tableCategoryText: { title: 'Category', type: 'InputLanguage' },
    tableCookieText: { title: 'Cookie', type: 'InputLanguage' },
    tableDomainText: { title: 'Domain', type: 'InputLanguage' },
    tableDurationText: { title: 'Duration', type: 'InputLanguage' },
  },
  'general content': {
    statusText: { title: 'Status', type: 'InputLanguage' },
    viewAllText: { title: 'View All', type: 'InputLanguage' },
    viewLessText: { title: 'View Less', type: 'InputLanguage' },
    acceptedAllText: { title: 'Accepted All Status', type: 'InputLanguage' },
    partialConsentText: { title: 'Partial Consent Status', type: 'InputLanguage' },
    rejectedAllText: { title: 'Rejected All Status', type: 'InputLanguage' },
  },
  'toggle settings': {
    toggleType: { title: 'Type', type: 'ToggleType' },
    toggleColor: { title: 'ON Color', type: 'ColorPicker' },
    toggleActiveColor: { title: 'ON Active Text Color', type: 'ColorPicker' },
    toggleText: { title: 'ON Text', type: 'InputLanguage' },
    toggleOffColor: { title: 'OFF Color', type: 'ColorPicker' },
    toggleOffActiveColor: { title: 'OFF Active Text Color', type: 'ColorPicker' },
    toggleOffText: { title: 'OFF Text', type: 'InputLanguage' },
  }
};